export default __webpack_public_path__ + "static/icon-33-5-615e7aa700614010269192105386ff55.png";